import React, { useEffect, createElement } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
interface LayoutProps {
  children: React.ReactNode;
}
const SITE_TITLE = 'Brixen Credit — Credit Education & Financial Consulting';
const SITE_DESCRIPTION = 'Brixen Credit provides education-first credit and financial consulting. We teach you how credit works, clearly and transparently. We are not a credit bureau, lender, or law firm.';
function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
export function Layout({
  children
}: LayoutProps) {
  // Brand SEO: title, meta description, and Open Graph tags.
  useEffect(() => {
    document.title = SITE_TITLE;
    upsertMeta('name', 'description', SITE_DESCRIPTION);
    upsertMeta('property', 'og:title', SITE_TITLE);
    upsertMeta('property', 'og:description', SITE_DESCRIPTION);
    upsertMeta('property', 'og:site_name', 'Brixen Credit');
    upsertMeta('property', 'og:type', 'website');
    upsertMeta('property', 'og:url', 'https://brixencredit.com');
    upsertMeta('property', 'og:image', 'https://cdn.magicpatterns.com/uploads/pBeDZwLFT6NbwtKUvYGrxZ/Asset_21x.png');
  }, []);
  // Embed the GHL chat widget on every page (required for A2P 10DLC compliance).
  // This is the ONLY data-collection method on the site.
  useEffect(() => {
    const SCRIPT_SRC = 'https://widgets.leadconnectorhq.com/loader.js';
    if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) return;
    const script = document.createElement('script');
    script.src = SCRIPT_SRC;
    script.async = true;
    script.setAttribute('data-resources-url', 'https://widgets.leadconnectorhq.com/chat-widget/loader.js');
    script.setAttribute('data-widget-id', '6a240ccded0ee22f92081f38');
    script.setAttribute('data-source', 'WEB_USER');
    document.body.appendChild(script);
  }, []);
  return <div className="flex min-h-screen flex-col bg-white" data-id="element-111">
      <Header data-id="element-112" />
      <main className="flex-1" data-id="element-113">{children}</main>
      <Footer data-id="element-114" />
    </div>;
}